import { render, staticRenderFns } from "./delete_registration_alert.vue?vue&type=template&id=4074b7c9"
import script from "./delete_registration_alert.vue?vue&type=script&lang=js"
export * from "./delete_registration_alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports